import { render, staticRenderFns } from "./type-dakkapel.vue?vue&type=template&id=f1f516b0"
import script from "./type-dakkapel.vue?vue&type=script&lang=js"
export * from "./type-dakkapel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports